import React from 'react';
import DocContent from './DocContent';
import { blocks } from '../content/ChapterCommitteesContent';

export default function ChapterCommittees() {
  return <DocContent blocks={blocks} />;
}
